import PropTypes from 'prop-types'
/**
 * @typedef {Object} Agency
 * @property {number} id - The unique identifier of the agency.
 * @property {string} name - The name of the agency.
 * @property {boolean} maintenance_mode - The maintenance mode status, or null if not set.
 * @property {string} agency_plan_name - The name of the associated agency plan, or an empty string if not set.
 * @property {string|null} owner_name - The name of the agency owner, or null if not set.
 * @property {string|null} owner_email - The email of the agency owner, or null if not set.
 * @property {string|null} account_status - The account status, or null if not set.
 * @property {string|null} hubspot_link - The HubSpot link, or null if not set.
 * @property {number|null} agency_plan_id - The ID of the associated agency plan, or null if not assigned.
 */

export const agencyPropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  maintenance_mode: PropTypes.bool,
  agency_plan_name: PropTypes.string,
  owner_name: PropTypes.string,
  owner_email: PropTypes.string,
  account_status: PropTypes.string,
  hubspot_link: PropTypes.string,
  agency_plan_id: PropTypes.number
})

/**
 * @typedef {Agency[]} Agencies
 */

export const agenciesPropTypes = PropTypes.arrayOf(agencyPropTypes)

/**
 * @typedef {Object} AgencyState
 * @property {Agencies} agencies - The list of agencies.
 */

export const agencyStatePropTypes = PropTypes.shape({
  agencies: PropTypes.arrayOf(agencyPropTypes)
})

/** @type {AgencyState} */
const initialState = {
  agencies: []
}

/**
 *
 * @param {AgencyState} state
 * @param {{ type: string, payload: Agencies }} action
 *
 * @returns {AgencyState}
 */
const agenciesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'SET_AGENCIES':
      return {
        ...state,
        agencies: payload
      }
    default:
      return state
  }
}

export default agenciesReducer
